export function selectProductId(vars, analyticsProductIdType) {
  switch (analyticsProductIdType) {
    case "id":
      return vars.externalId;
    case "sku":
      return vars.sku;
    default:
      return vars.externalId;
  }
}
